// Typelizer digest 8e5160ad0f48c9ecb8f714832f184b85
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /c/:company_id/purchase_orders */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/purchase_orders', {}, options),
    method: 'get',
  }),

  /** POST /c/:company_id/purchase_orders */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/purchase_orders', {}, options),
    method: 'post',
  }),

  /** GET /c/:company_id/purchase_orders/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/purchase_orders/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /c/:company_id/purchase_orders/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/purchase_orders/:id', params, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/purchase_orders/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/purchase_orders/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/purchase_orders/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/purchase_orders/:id', params, options),
    method: 'delete',
  }),
}
